// @ts-strict-ignore

/**
 * @module UserNetwork
 */

import { UserInfoService } from 'rainbow-web-sdk/services/core/userInfo.service';
import { User } from './user.model';

/**
 * This class is used to represent an invitation received or sent by/to user <br/>
 */
export class NetworkInvitation {

    /* *********************************************************** */
    /* STATIC FACTORIES                                            */
    /* *********************************************************** */
    public static create(id: string, invitedUserId: string, invitedUserEmail: string, invitingUserId: string, invitingUserEmail: string, requestNotificationLanguage: string, invitingDate: string, lastNotificationDate: string, status: string, type: string, inviteToJoinMeeting: string): NetworkInvitation {
        return new NetworkInvitation(id, invitedUserId, invitedUserEmail, invitingUserId, invitingUserEmail, requestNotificationLanguage, invitingDate, lastNotificationDate, status, type, inviteToJoinMeeting);
    }

    public static createFromData(invitationData: any): NetworkInvitation {
        const invitation = new NetworkInvitation(invitationData.id, invitationData.invitedUserId, invitationData.invitedUserEmail,
            invitationData.invitingUserId, invitationData.invitingUserEmail, invitationData.requestNotificationLanguage,
            invitationData.invitingDate, invitationData.lastNotificationDate, invitationData.status, invitationData.type,
            invitationData.inviteToJoinMeeting, invitationData.invitedPhoneNumber);
        invitation.createDefaultAvatar();
        return invitation;
    }

    /**
     * The invitation ID
     * @readonly
     */
    public id: string;

    /**
     * The invited user
     * @readonly
     */
    public invitedUser?: User;

    /**
     * The invited user Rainbow id
     * @readonly
     */
    public invitedUserId: string;

    /**
     * The invited user email
     * @readonly
    */
    public invitedUserEmail: string;

    /**
     * The invited phone number
     * @readonly
     */
    public invitedPhoneNumber: string;

    /**
     * The inviting user
     * @readonly
     */
    public invitingUser?: User;

    /**
     * The inviting user identifier
     * @readonly
     */
    public invitingUserId: string;

    /**
     * The inviting user email adress
     * @readonly
     */
    public invitingUserEmail: string;

    /**
     * The request notification language
     * @readonly
     */
    public requestNotificationLanguage: string;

    /**
     * The date the invitation was created
     * @readonly
     */
    public invitingDate: string;

    /**
     * The date when the last email notification was sent.
     * @readonly
     */
    public lastNotificationDate: string;

    /**
     * The invitation status
     * @readonly
     */
    public status: string;

    /**
     * The invitation type
     * @readonly
     */
    public type: string;

    /**
     * True if joinRoom invitation.
     * @readonly
     */
    public inviteToJoinMeeting: string;

    /**
     * The invitation default avatar
     * @readonly
     */
    public defaultAvatar: any;

    /** @internal */
    constructor(id: string, invitedUserId: string, invitedUserEmail: string, invitingUserId: string, invitingUserEmail: string, requestNotificationLanguage: string, invitingDate: string,
        lastNotificationDate: string, status: string, type: string, inviteToJoinMeeting: any, invitedPhoneNumber: string = null) {

        this.id = id;
        this.invitedUserId = invitedUserId;
        this.invitedUserEmail = invitedUserEmail;
        this.invitedPhoneNumber = invitedPhoneNumber;
        this.invitingUserId = invitingUserId;
        this.invitingUserEmail = invitingUserEmail;
        this.requestNotificationLanguage = requestNotificationLanguage;
        this.invitingDate = invitingDate;
        this.lastNotificationDate = lastNotificationDate;//fix #24157
        this.status = status;
        this.type = type;
        this.defaultAvatar = null;
        this.inviteToJoinMeeting = inviteToJoinMeeting;
    }

    public createDefaultAvatar() {
        if (!this.defaultAvatar && this.invitedUserEmail) {
            const userInfoService = UserInfoService.getInstance();
            const colorInfo = userInfoService.computeUserColor(this.invitedUserEmail);
            const initials = this.invitedUserEmail.substring(0, 2).toUpperCase();
            this.defaultAvatar = userInfoService.createDefaultAvatarImage(initials, colorInfo.color);
        }
    }

    public toJSON(): any {
        const json: any = {};
        json.id = this.id;
        json.type = this.type;
        json.status = this.status;
        json.invitingDate = this.invitingDate;
        if (this.invitedUserId) json.invitedUserId = this.invitedUserId;
        if (this.invitedUserEmail) json.invitedUserEmail = this.invitedUserEmail;
        if (this.invitingUserId) json.invitingUserId = this.invitingUserId;
        if (this.invitingUserEmail) json.invitingUserEmail = this.invitingUserEmail;
        return json;
    }
}
